import { Button, Pagination } from 'components'
import { useNewLeaderBoard } from 'features/Leaderboard'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React from 'react'

const Leaderboard = dynamic(() => import('../components/Leaderboard'))

const paginationData = {
  pageSize: 15,
  siblingCount: 1
}

const FrontendLeaderboardPage = () => {
  const router = useRouter()
  const { page, timeline } = router.query

  const currentPage = typeof page === 'string' ? parseInt(page) || 1 : 1
  const currentTimeline =
    typeof timeline === 'string' ? timeline || 'monthly' : 'monthly'

  if (!['monthly', 'weekly'].includes(currentTimeline))
    router.push('/frontend-leaderboard')

  const { data: frontendLeaderboardData, isLoading } = useNewLeaderBoard(
    currentPage,
    'frontend',
    currentTimeline,
    paginationData.pageSize
  )

  if (
    (!frontendLeaderboardData ||
      Object.keys(frontendLeaderboardData).length === 0 ||
      currentPage >
        Math.ceil(frontendLeaderboardData.count / paginationData.pageSize)) &&
    !isLoading
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen w-full">
        <div className="text-4xl text-indigo-500 text-center font-bold my-8">
          The Page You are looking for does not Exist!
        </div>
        <div className="flex flex-col text-center items-center gap-4 ">
          <div>
            Click on this button to go on Frontend Leaderboard Page -&gt;
          </div>

          <Button
            className={'flex justify-center text-center max-w-[70%]'}
            variant={'primary'}
            onClick={() => router.push('/frontend-leaderboard')}>
            Frontend Leaderboard
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
      <Leaderboard
        key={'Frontend'}
        leaderboardData={frontendLeaderboardData}
        courseType={'Frontend'}
        isLoading={isLoading}
        currentTimeline={currentTimeline}
        onCourseTimelineChange={(val: string) =>
          router.push(
            `/frontend-leaderboard?page=${currentPage}&timeline=${val}`
          )
        }
      />
      <div className="overflow-x-auto  flex justify-center items-center">
        <Pagination
          onPageChange={(val) =>
            router.push(
              `/frontend-leaderboard?page=${val}&timeline=${currentTimeline}`
            )
          }
          currentPage={currentPage}
          pageSize={paginationData.pageSize}
          siblingCount={paginationData.siblingCount}
          totalCount={frontendLeaderboardData?.count || 0}
        />
      </div>
    </>
  )
}

FrontendLeaderboardPage.auth = {
  shouldBeLoggedIn: true
}

FrontendLeaderboardPage.layout = {
  navProps: {
    type: 'product'
  }
}

FrontendLeaderboardPage.seo = {
  title: 'Frontend Leaderboard | Devsnest'
}

export default FrontendLeaderboardPage
